import * as tslib_1 from "tslib";
import React from 'react';
export var MatureContext = React.createContext(false);
// HOC for convenience...
export var withMatureContext = function (Component) { return function (props) {
    return (React.createElement(MatureContext.Consumer, null, function (showMatureContent) { return (React.createElement(Component, tslib_1.__assign({ showMatureContent: showMatureContent }, props))); }));
}; };
//# sourceMappingURL=MatureContext.js.map